export enum ListingType {
  Direct = 0,
  Auction = 1,
}
